// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"43":"test","443":"about"}[chunkId] + "." + {"43":"77e39f53","443":"7839fb6c"}[chunkId] + ".js";
};